import React from 'react';
import PropTypes from 'prop-types';
import launchModal from './messages';

const IPropTypes = {
  children: PropTypes.any,
  showModal: PropTypes.bool,
  type: PropTypes.string,
  id: PropTypes.string,
  extraMessage: PropTypes.string,
  asHtml: PropTypes.bool,
  textConfirm: PropTypes.string,
  showConfirm: PropTypes.bool,
  actionConfirm: PropTypes.func,
  textCancel: PropTypes.string,
  showCancel: PropTypes.bool,
  actionCancel: PropTypes.func,
};

const defaultProps = {
  children: '',
  showModal: false,
  type: '',
  id: '',
  extraMessage: '',
  asHtml: true,
  textConfirm: 'Aceptar',
  showConfirm: true,
  actionConfirm: null,
  textCancel: 'Cancelar',
  showCancel: true,
  actionCancel: null,
};

class InfoModal extends React.Component {
  constructor(props) {
    super(props);
    this._showModal = this._showModal.bind(this);
    this._renderOnButtonWithAction = this._renderOnButtonWithAction.bind(this);
    this._renderOnComponentChild = this._renderOnComponentChild.bind(this);
  }

  _showModal() {
    launchModal(
      this.props.id, this.props.extraMessage, this.props.asHtml, null,
      this.props.textConfirm, this.props.showConfirm, this.props.actionConfirm,
      this.props.textCancel, this.props.showCancel, this.props.actionCancel,
    );
  }

  _renderOnButtonWithAction() {
    if (this.props.showModal) {
      const childrenWithProps = React.Children.map(this.props.children, child =>
        React.cloneElement(child, { onClick: () => this._showModal() }));
      return childrenWithProps;
    }
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, { onClick: this.props.actionConfirm }));
    return childrenWithProps;
  }

  _renderOnComponentChild() {
    if (this.props.showModal) {
      const childrenWithProps = React.Children.map(this.props.children, child =>
        React.cloneElement(child, { onClick: () => this._showModal() }));
      return <div style={{ cursor: 'pointer' }}>{childrenWithProps}</div>;
    }
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, { onClick: this.props.actionConfirm }));
    return childrenWithProps;
  }

  render() {
    switch (this.props.type) {
      case 'button-with-action':
        return this._renderOnButtonWithAction();
      case 'component':
        return this._renderOnComponentChild();
      default:
        return this._renderOnComponentChild();
    }
  }
}

InfoModal.propTypes = IPropTypes;
InfoModal.defaultProps = defaultProps;

export { InfoModal };



// WEBPACK FOOTER //
// ./src/common/info-modal/InfoModal.jsx